export const EDINBURGHCLLRS = [
	{
		name: "Robert Aldridge",
		ward: "Drum Brae/Gyle",
		party: "Liberal Democrats",
		email: "robert.aldridge@edinburgh.gov.uk",
		twitter: "none",
	},
	{
		name: "Danny Aston",
		ward: "Craigentinny/Duddingston",
		party: "SNP",
		email: "Cllr.Danny.Aston@edinburgh.gov.uk",
		twitter: "@DAstonSNP",
	},
	{
		name: "Jule Bandel",
		ward: "Inverleith",
		party: "Green",
		email: "Cllr.Jule.Bandel@edinburgh.gov.uk",
		twitter: "@julebandel",
	},
	{
		name: "Alan Beal",
		ward: "Corstorphine/Murrayfield",
		party: "Liberal Democrats",
		email: "Cllr.Alan.Beal@edinburgh.gov.uk",
		twitter: "none",
	},
	{
		name: "Fiona Bennett",
		ward: "Corstorphine/Murrayfield",
		party: "Liberal Democrats",
		email: "cllr.fiona.bennett@edinburgh.gov.uk",
		twitter: "none",
	},
	{
		name: "Chas Booth",
		ward: "Leith",
		party: "Green",
		email: "chas.booth@edinburgh.gov.uk",
		twitter: "@CllrChasBooth",
	},
	{
		name: "Graeme Bruce",
		ward: "Pentland Hills",
		party: "Conservatives",
		email: "graeme.bruce@edinburgh.gov.uk",
		twitter: "none",
	},
	{
		name: "Steve Burgess",
		ward: "Southside/Newington",
		party: "Green",
		email: "Steve.Burgess@edinburgh.gov.uk",
		twitter: "none",
	},
	{
		name: "Jack Caldwell",
		ward: "Leith Walk",
		party: "Liberal Democrats",
		email: "Cllr.Jack.Caldwell@edinburgh.gov.uk",
		twitter: "@JackRMCaldwell",
	},
	{
		name: "Lezley Marion Cameron",
		ward: "Liberton/Gilmerton",
		party: "Labour",
		email: "lezleymarion.cameron@edinburgh.gov.uk",
		twitter: "@lezleymarion",
	},
	{
		name: "Kate Campbell",
		ward: "Portobello/Craigmillar",
		party: "SNP",
		email: "kate.campbell@edinburgh.gov.uk",
		twitter: "@KateC_SNP",
	},
	{
		name: "Martha Mattos Coelho",
		ward: "Liberton/Gilmerton",
		party: "SNP",
		email: "Cllr.Martha.MattosCoelho@edinburgh.gov.uk",
		twitter: "@MthMttCoe",
	},
	{
		name: "Christopher Cowdy",
		ward: "Fountainbridge/Craiglockhart",
		party: "Conservatives",
		email: "Cllr.Christopher.Cowdy@edinburgh.gov.uk",
		twitter: "@CouncillorCowdy",
	},
	{
		name: "Neil Cuthbert",
		ward: "Colinton/Fairmilehead",
		party: "Conservatives",
		email: "cllr.neil.cuthbert@edinburgh.gov.uk",
		twitter: "@cuthbertneil",
	},
	{
		name: "James Dalgleish",
		ward: "Leith Walk",
		party: "Labour",
		email: "Cllr.James.Dalgleish@edinburgh.gov.uk",
		twitter: "@james_dalgleish",
	},
	{
		name: "Euan Davidson",
		ward: "Corstorphine/Murrayfield",
		party: "Liberal Democrats",
		email: "Cllr.Euan.Davidson@edinburgh.gov.uk",
		twitter: "@euandavidson",
	},
	{
		name: "Cammy Day",
		ward: "Forth",
		party: "Independent",
		email: "Cammy.Day@edinburgh.gov.uk",
		twitter: "none",
	},
	{
		name: "Sanne Dijkstra-Downie",
		ward: "Forth",
		party: "Liberal Democrats",
		email: "Cllr.Sanne.Dijkstra-Downie@edinburgh.gov.uk",
		twitter: "none",
	},
	{
		name: "Denis Dixon",
		ward: "Sighthill/Gorgie",
		party: "SNP",
		email: "denis.dixon@edinburgh.gov.uk",
		twitter: "@DenisDixonSNP",
	},
	{
		name: "Stuart Dobbin",
		ward: "Forth",
		party: "SNP",
		email: "Cllr.Stuart.Dobbin@edinburgh.gov.uk",
		twitter: "none",
	},
	{
		name: "Phil Doggart",
		ward: "Liberton/Gilmerton",
		party: "Conservatives",
		email: "phil.doggart@edinburgh.gov.uk",
		twitter: "@PhilipDoggart",
	},
	{
		name: "Katrina Faccenda",
		ward: "Leith",
		party: "Labour",
		email: "Cllr.Katrina.Faccenda@edinburgh.gov.uk",
		twitter: "@KatrinaFaccenda",
	},
	{
		name: "Pauline Flannery",
		ward: "Southside/Newington",
		party: "Liberal Democrats",
		email: "Cllr.Pauline.Flannery@edinburgh.gov.uk",
		twitter: "none",
	},
	{
		name: "Catherine Fullerton",
		ward: "Sighthill/Gorgie",
		party: "SNP",
		email: "cathy.fullerton@edinburgh.gov.uk",
		twitter: "none",
	},
	{
		name: "Neil Gardiner",
		ward: "Pentland Hills",
		party: "SNP",
		email: "neil.gardiner@edinburgh.gov.uk",
		twitter: "none",
	},
	{
		name: "Fiona Glasgow",
		ward: "Pentland Hills",
		party: "SNP",
		email: "Cllr.Fiona.Glasgow@edinburgh.gov.uk",
		twitter: "@FionaCllr",
	},
	{
		name: "Margaret Graham",
		ward: "City Centre",
		party: "Labour",
		email: "Cllr.Margaret.Graham@edinburgh.gov.uk",
		twitter: "none",
	},
	{
		name: "Joan Griffiths",
		ward: "Craigentinny/Duddingston",
		party: "Labour",
		email: "joan.griffiths@edinburgh.gov.uk",
		twitter: "@joan_griffiths",
	},
	{
		name: "Dan Heap",
		ward: "Sighthill/Gorgie",
		party: "Green",
		email: "Cllr.Dan.Heap@edinburgh.gov.uk",
		twitter: "@CllrDanHeap",
	},
	{
		name: "Euan Hyslop",
		ward: "Drum Brae/Gyle",
		party: "SNP",
		email: "Cllr.Euan.Hyslop@edinburgh.gov.uk",
		twitter: "@EuanHyslop",
	},
	{
		name: "Stephen Jenkinson",
		ward: "Pentland Hills",
		party: "Labour",
		email: "Cllr.Stephen.Jenkinson@edinburgh.gov.uk",
		twitter: "@sjenkinson76",
	},
	{
		name: "Tim Jones",
		ward: "Portobello/Craigmillar",
		party: "Conservatives",
		email: "Cllr.Tim.Jones@edinburgh.gov.uk",
		twitter: "none",
	},
	{
		name: "David Key",
		ward: "Fountainbridge/Craiglockhart",
		party: "SNP",
		email: "david.key@edinburgh.gov.uk",
		twitter: "@davidfkey",
	},
	{
		name: "Simita Kumar",
		ward: "Southside/Newington",
		party: "SNP",
		email: "Cllr.Simita.Kumar@edinburgh.gov.uk",
		twitter: "@SimitaSKumar",
	},
	{
		name: "Kevin Lang",
		ward: "Almond",
		party: "Liberal Democrats",
		email: "kevin.lang@edinburgh.gov.uk",
		twitter: "@kevin_lang",
	},
	{
		name: "Lesley Macinnes",
		ward: "Liberton/Gilmerton",
		party: "SNP",
		email: "lesley.macinnes@edinburgh.gov.uk",
		twitter: "@lmacinnessnp",
	},
	{
		name: "Marie-Clair Munro",
		ward: "Morningside",
		party: "Conservatives",
		email: "Cllr.Marie-Clair.Munro@edinburgh.gov.uk",
		twitter: "none",
	},
	{
		name: "Finlay McFarlane",
		ward: "City Centre",
		party: "SNP",
		email: "Cllr.Finlay.Mcfarlane@edinburgh.gov.uk",
		twitter: "@FinlayMcF",
	},
	{
		name: "Ross McKenzie",
		ward: "Sighthill/Gorgie",
		party: "Independent",
		email: "Cllr.Ross.Mckenzie@edinburgh.gov.uk",
		twitter: "@rsmcksg",
	},
	{
		name: "Amy McNeese-Mechan",
		ward: "Leith Walk",
		party: "SNP",
		email: "cllr.amy.mcneese-mechan@edinburgh.gov.uk",
		twitter: "@AMcNeeseMechan",
	},
	{
		name: "Jane Meagher",
		ward: "Portobello/Craigmillar",
		party: "Labour",
		email: "Cllr.Jane.Meagher@edinburgh.gov.uk",
		twitter: "none",
	},
	{
		name: "Claire Miller",
		ward: "City Centre",
		party: "Green",
		email: "C.Miller@edinburgh.gov.uk",
		twitter: "@CllrCMiller",
	},
	{
		name: "Max Mitchell",
		ward: "Inverleith",
		party: "Conservatives",
		email: "max.mitchell@edinburgh.gov.uk",
		twitter: "@maxmitchell91",
	},
	{
		name: "Joanna Mowat",
		ward: "City Centre",
		party: "Conservatives",
		email: "cllr.jo.mowat@edinburgh.gov.uk",
		twitter: "none",
	},
	{
		name: "Alys Mumford",
		ward: "Portobello/Craigmillar",
		party: "Green",
		email: "Cllr.Alys.Mumford@edinburgh.gov.uk",
		twitter: "@AlysGreens",
	},
	{
		name: "Vicky Nicolson",
		ward: "Inverleith",
		party: "SNP",
		email: "Cllr.Vicky.Nicolson@edinburgh.gov.uk",
		twitter: "none",
	},
	{
		name: "Adam Nols-McVey",
		ward: "Leith",
		party: "SNP",
		email: "adam.mcvey@edinburgh.gov.uk",
		twitter: "@adamrmcvey",
	},
	{
		name: "Kayleigh O'Neill",
		ward: "Forth",
		party: "Green",
		email: "Cllr.Kayleigh.ONeill@edinburgh.gov.uk",
		twitter: "@KayleighFONeill",
	},
	{
		name: "Hal Osler",
		ward: "Inverleith",
		party: "Liberal Democrats",
		email: "hal.osler@edinburgh.gov.uk",
		twitter: "@HalOsler",
	},
	{
		name: "Ben Parker",
		ward: "Morningside",
		party: "Green",
		email: "Cllr.Ben.Parker@edinburgh.gov.uk",
		twitter: "@CllrBenParker",
	},
	{
		name: "Tim Pogson",
		ward: "Southside/Newington",
		party: "Labour",
		email: "Cllr.Tim.Pogson@edinburgh.gov.uk",
		twitter: "none",
	},
	{
		name: "Susan Rae",
		ward: "Leith Walk",
		party: "Green",
		email: "susan.rae@edinburgh.gov.uk",
		twitter: "@susan4leithwalk",
	},
	{
		name: "Neil Ross",
		ward: "Morningside",
		party: "Liberal Democrats",
		email: "neil.ross@edinburgh.gov.uk",
		twitter: "none",
	},
	{
		name: "Jason Rust",
		ward: "Colinton/Fairmilehead",
		party: "Conservatives",
		email: "jason.rust@edinburgh.gov.uk",
		twitter: "none",
	},
	{
		name: "Conor Savage",
		ward: "Colinton/Fairmilehead",
		party: "Labour",
		email: "cllr.conor.savage@edinburgh.gov.uk",
		twitter: "none",
	},
	{
		name: "Alex Staniforth",
		ward: "Craigentinny/Duddingston",
		party: "Green",
		email: "alex.staniforth@edinburgh.gov.uk",
		twitter: "none",
	},
	{
		name: "Edward Thornley",
		ward: "Drum Brae/Gyle",
		party: "Liberal Democrats",
		email: "Cllr.Edward.Thornley@edinburgh.gov.uk",
		twitter: "@edjthornley",
	},
	{
		name: "Mandy Watt",
		ward: "Morningside",
		party: "Labour",
		email: "mandy.watt@edinburgh.gov.uk",
		twitter: "none",
	},
	{
		name: "Iain Whyte",
		ward: "Craigentinny/Duddingston",
		party: "Conservatives",
		email: "iain.whyte@edinburgh.gov.uk",
		twitter: "@CllrWhyte",
	},
	{
		name: "Norman Work",
		ward: "Almond",
		party: "SNP",
		email: "norman.work@edinburgh.gov.uk",
		twitter: "@CllrNormanWork",
	},
	{
		name: "Louise Young",
		ward: "Almond",
		party: "Liberal Democrats",
		email: "louise.young@edinburgh.gov.uk",
		twitter: "none",
	},
	{
		name: "Lewis Younie",
		ward: "Almond",
		party: "Liberal Democrats",
		email: "Cllr.Lewis.Younie@edinburgh.gov.uk",
		twitter: "@Lewis_Younie",
	},
];
